const COMPUTER_PLATFORM_TITLES = new Set(['pc', 'computer', 'کامپیوتر'])

const isComputerPlatformTitle = (title) =>
  COMPUTER_PLATFORM_TITLES.has((title || '').trim().toLowerCase())

const collectPlatformIds = (platform, ids) => {
  ids.add(platform.id)
  platform.children?.forEach((child) => collectPlatformIds(child, ids))
}

export const getComputerPlatformIds = (platforms) => {
  const ids = new Set()

  if (!platforms?.length) return ids

  platforms.forEach((platform) => {
    if (platform.parentId == null && isComputerPlatformTitle(platform.title)) {
      collectPlatformIds(platform, ids)
    }
  })

  return ids
}

export const hasComputerPlatformSelected = (platformIds, platforms) => {
  if (!platformIds?.length || !platforms?.length) return false

  const computerPlatformIds = getComputerPlatformIds(platforms)
  return platformIds.some((id) => computerPlatformIds.has(id))
}
